<template>
  <table class="admin_bracket_roundRobin_table">
    <tr>
      <th></th>
      <th v-for="teamY in teamsOrdered" :key="teamY.id" :class="{ draggable: bracket.editable }" :draggable="bracket.editable" @dragstart="dragTeamBracketStart(teamY)">{{ getTeamName(teamY) | team_name_full }}</th>
      <th>Pořadí</th>
      <th>Váha</th>
    </tr>
    <tr v-for="teamX in teamsOrdered" :key="teamX.id">
      <th :class="{ draggable: bracket.editable }" :draggable="bracket.editable" @dragstart="dragTeamBracketStart(teamX)">{{ getTeamName(teamX) | team_name_full }}</th>
      <td v-for="teamY in teamsOrdered" :key="teamY.id">
        <match :teamX="teamX" :teamY="teamY" :bracketId="bracket.id" />
      </td>
      <th
        class="draggable"
        :class="{ decisionRequired: teamX.standingDecisionRequired }"
        draggable="true"
        @dragenter="dragStandingEnter(teamX)"
        @dragleave="dragStandingLeave(teamX)"
        @dragend="dragStandingEnd(teamX)"
        @dragover="droppable"
      >{{ bracketIsPlayed ? teamX.bracketStanding + 1 : "" }}</th>
      <th :class="{ decisionRequired: teamX.standingDecisionRequired }">{{ bracketIsPlayed ? teamX.strength : "" }}</th>
    </tr>
  </table>
</template>

<script>
import { _ } from "../../../extend";
import match from "./bracket_roundRobin_table_match";

export default {
  name: "admin_bracket_roundRobin_table",
  components: {
    match
  },
  props: {
    bracket: {},
  },
  data: () => ({
    draggedIsOverTeam: null,
  }),
  computed: {
    bracketTeams() {
      const bracketTeams = _.filter(this.$store.state.bracketTeams, bt => bt.bracketId == this.bracket.id);
      return bracketTeams;
    },
    teamsOrdered() {
      var ordered = _.order(this.bracketTeams, t => t.teamId);
      var result = ordered.map(t => {
        var sameStrength = _.filter(this.bracketTeams, bt => bt.strength == t.strength && !bt.decidedByAdmin && !t.decidedByAdmin);
        return {
          ...this.$store.state.teams[t.teamId],
          ...t,
          standingDecisionRequired: _.count(sameStrength) > 1,
        }
      });
      return result;
    },
    bracketMatches() {
      return _.filter(this.$store.getters.matchesWithRelatedData, m => m.bracketId == this.bracket.id);
    },
    bracketIsPlayed() {
      return _.any(this.bracketMatches, m => m.scoreA > 0 || m.scoreB > 0);
    }
  },
  methods: {
    getTeamName(team) {
      if (team.teamId != null) {
        return { id: team.teamId, outpostId: team.outpostId };
      }

      return team.advancingOrder + 1;
    },
    dragStandingEnter(team) {
      this.draggedIsOverTeam = team;
    },
    dragStandingLeave(team) {
      if (team.id == this.draggedIsOverTeam.id) {
        this.draggedIsOverTeam = null;
      }
    },
    dragStandingEnd(draggedTeam) {
      if (this.draggedIsOverTeam == null || draggedTeam.id == this.draggedIsOverTeam.id) {
        return;
      }

      // bracketStanding
      this.$store.commit('update', {
        paths: ['bracketTeams', draggedTeam.id, 'bracketStanding'],
        value: this.draggedIsOverTeam.bracketStanding,
      });
      this.$store.commit('update', {
        paths: ['bracketTeams', this.draggedIsOverTeam.id, 'bracketStanding'],
        value: draggedTeam.bracketStanding,
      });

      // decidedByAdmin
      this.$store.commit('update', {
        paths: ['bracketTeams', draggedTeam.id, 'decidedByAdmin'],
        value: true,
      });
      this.$store.commit('update', {
        paths: ['bracketTeams', this.draggedIsOverTeam.id, 'decidedByAdmin'],
        value: true,
      });

      this.draggedIsOverTeam = null;
    },
    droppable(ev) {
      ev.preventDefault();
    },

    dragTeamBracketStart(team) {
      if (!this.bracket.editable) {
        return;
      }
      
      this.$emit('teamDragged', team.teamId, this.bracket.id);
    },
  }
}
</script>

<style lang="sass">
@import "../../../sass/_constants.sass"

.admin_bracket_roundRobin_table
  border-spacing: 0
  th, td
    padding: .3rem .5rem
  th
    font-weight: bold
  tr th:first-child
    border-right: 2px solid $bc-secondary
  tr:first-child th
    border-bottom: 2px solid $bc-secondary
  
  .decisionRequired
    color: $c-danger

  .draggable
    cursor: move

  tr td span
    display: grid
    justify-content: center
</style>
